export const PAGE_SIZE = 16;
export const PCC_CATEGORY_PAGE = 'PCC Category Page';
export const SUBCATEGORY_COOKIE = 'mypcc_pcc_redirect=1';
